import { useEffect } from "react";
import { RxCross1 } from "react-icons/rx";
import { InstallmentListProps, PayrollProps } from "../usePayroll";
import "./styles.scss";
import { useModalImport } from "./useModalImport";
interface ModalImportProps {
  handleCloseModal: () => void;
  installmentList?: InstallmentListProps[];
  setNewList: React.Dispatch<React.SetStateAction<PayrollProps>>;
}
export function ModalImport({
  handleCloseModal,
  installmentList,
  setNewList,
}: ModalImportProps) {
  const { handleImport, setImportConfig } = useModalImport({
    handleCloseModal: handleCloseModal,
    setNewList: setNewList,
    installmentList: installmentList,
  });

  useEffect(() => {
    setImportConfig((prevState) => {
      return {
        ...prevState,
        prestacaoContaId: installmentList[0].prestacaoContaId,
      };
    });
  }, []);

  return (
    <div className="modal-import-container">
      <header>
        <RxCross1 onClick={() => handleCloseModal()} />
      </header>
      <main>
        <div className="modal-import-input-card">
          <p>Mês</p>
          <input
            type="month"
            onBlur={(e) =>
              setImportConfig((prevState) => {
                return {
                  ...prevState,
                  mes: Number(e.target.value.split("-")[1]),
                  ano: Number(e.target.value.split("-")[0]),
                };
              })
            }
          />
        </div>
        <div className="modal-import-input-card">
          <p>Prestação Conta</p>
          <select
            onChange={(e) =>
              setImportConfig((prevState) => {
                return {
                  ...prevState,
                  prestacaoContaId: Number(e.target.value),
                };
              })
            }
          >
            {installmentList.map((installment) => (
              <option
                key={installment.prestacaoContaId}
                value={installment.prestacaoContaId}
              >
                {installment.vigencia}
              </option>
            ))}
          </select>
        </div>
      </main>
      <footer>
        <button type="submit" onClick={() => handleImport()}>
          Confirmar
        </button>
        <button onClick={() => handleCloseModal()}>Cancelar</button>
      </footer>
    </div>
  );
}
